'use strict';
/* eslint @okta/okta-ui/no-specific-modules: 0 */
import Handlebars from 'handlebars';

// Display a base 64 encoded data (e.g. certificate signature) in a nicely formatted hex format.
Handlebars.registerHelper('base64ToHex', function (base64String) {
  const raw = atob(base64String);
  let result = '';
  if (raw.length > 0) {
    const firstHex = raw.charCodeAt(0).toString(16);
    result += (firstHex.length === 2 ? firstHex : '0' + firstHex);
    for (let i = 1; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += ' ' + (hex.length === 2 ? hex : '0' + hex);
    }
  }
  return result.toUpperCase();
});

export default Handlebars;



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/handlebars/helper-base64.js